import Model from 'flarum/common/Model';
import Tag from 'ext:flarum/tags/common/models/Tag';
export default function () {
  Tag.prototype.blomstraPtpProduct = Model.attribute('blomstraPtpProduct');
  Tag.prototype.blomstraPtvProduct = Model.attribute('blomstraPtvProduct');
  Tag.prototype.blomstraPtvVisibleFrom = Model.attribute('blomstraPtvVisibleFrom');
  Tag.prototype.blomstraPtbProduct = Model.attribute('blomstraPtbProduct');
  Tag.prototype.blomstraPtbBumpOthers = Model.attribute('blomstraPtbBumpOthers');
  Tag.prototype.blomstraBountyProduct = Model.attribute('blomstraBountyProduct');
}